<template>
  <div class="translation-container">
    <div v-if="!show_translations">
      <select
        v-if="target_language"
        @change="$store.dispatch('googleTranslate/updateTargetLanguage', $event.target.value)"
      >
        <option
          v-for="language in languages"
          :key="language.lang"
          :value="language.lang"
          :selected="target_language.lang === language.lang"
          >{{ language.native_title ? language.native_title : language.english_title }}</option
        >
      </select>

      <button @click="$store.dispatch('googleTranslate/translate', currentQuestionIndex)">
        Language Aid
      </button>

      <p>Language Aid provides you with a rough machine translation of the questions in a wide range of target languages. Note that this translation comes with no guarantee, and it may not be a reliable representation of the intent of some questions. </p>
      
    </div>
    <div v-else>
      <button @click="$store.dispatch('googleTranslate/clear')">
        Remove translation
      </button>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  props: {
    currentQuestionIndex: {
      required: true,
      type: Number
    }
  },
  computed: {
    ...mapState('googleTranslate', ['languages', 'target_language', 'show_translations'])
  },

  mounted() {
    this.$store.dispatch('googleTranslate/initTargetLanguage')
  }
}
</script>
